import React, { useState, useEffect, useCallback } from "react";
import info from "../../../assets/images/info.png";
import dollericon from "../../../assets/images/dollericon.png";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
// import { getTwoDecimalPlaces } from "../../../helpers/PriceDigest";
import CustomScrollbar from "../../shared/CustomScrollbar";
import {
  OrderQuotesMain,
  QuotesHead,
  QuotesContant,
  PriceSec,
  ButtonSec,
  ContactMain,
} from "./styles/OrderQuotesStyle";
import {
  ORDERSQUOTES,
  ACCEPTPRICEQUECTION,
} from "../../../constants/apiEndPoints";
import Loader from "../../shared/loader";
import { toast } from "react-hot-toast";
import httpRequest from "../../../axios/index";
import Tooltip from "@mui/material/Tooltip";
import NotFoundIcon from "../../shared/NotFoundIcon";

const OrderQuotes = () => {
  const navigate = useNavigate();
  const scrollbarHeight = "80vh";
  const [Loading, setLoading] = useState(false);
  const [BtnLoading, setBtnLoading] = useState(false);
  const [OrderQuotes, SetOrderQuotes] = useState([]);

  useEffect(() => {
    GetAllQuotes();
  }, []);

  const GetAllQuotes = async () => {
    try {
      setLoading(true);
      const resp = await httpRequest.get(`${ORDERSQUOTES}`);
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          SetOrderQuotes(resp?.data?.data);
        }
      }
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setLoading(false);
    }
  };

  const ActionsHaldler = useCallback(async (id, type) => {
    try {
      setBtnLoading(true);
      const resp = await httpRequest.post(
        `/orders/${id}${ACCEPTPRICEQUECTION}`,
        {
          order: {
            status: type,
          },
        }
      );
      if (resp?.status === 200) {
        if (resp?.data.message === "Success") {
          GetAllQuotes();
          if (type === "approved") {
            toast.success("Successfully approved");
          } else if (type === "cancelled") {
            toast.success("Successfully cancelled");
          }
        }
      }
      setBtnLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || "Something went wrong");
      setBtnLoading(false);
    }
  }, []);

  return (
    // <OrdersLayout>
    <ContactMain>
      <CustomScrollbar height={scrollbarHeight}>
        {Loading && <Loader />}

        {!Loading && OrderQuotes && OrderQuotes?.length > 0
          ? OrderQuotes.map((items) => {
              const { order_id, price, stops = [], eta = "" } = items;
              const SenderDetails =
                stops[0]?.contact_name + " , " + stops[0]?.location?.address;
              const ReceiverDetails =
                stops[1]?.contact_name + " , " + stops[1]?.location?.address;
              return (
                <OrderQuotesMain key={order_id}>
                  {stops && stops?.length > 0 && (
                    <>
                      <QuotesHead>
                        <div className="title">
                          <h6>{stops[0]?.order_detail?.name || "N/A"} </h6>
                        </div>
                        <img src={info} alt="info" />
                      </QuotesHead>

                      <QuotesContant>
                        <div className="">
                          <span>Sender: </span>
                          <Tooltip title={stops[0]?.location?.address} arrow>
                            <p>{SenderDetails || ""}</p>
                          </Tooltip>
                        </div>
                        <div className="">
                          <span>Receiver: </span>
                          <Tooltip title={stops[1]?.location?.address} arrow>
                            <p>{ReceiverDetails || ""}</p>
                          </Tooltip>
                        </div>
                      </QuotesContant>
                    </>
                  )}
                  <PriceSec>
                    {price && (
                      <div className="price_sec">
                        <img src={dollericon} alt="dollericon" />
                        {/* <span>${getTwoDecimalPlaces(price)}</span> */}
                        <span>${price}</span>
                      </div>
                    )}
                    <div className="time_sec">
                      <h6>ETA:</h6>
                      <span>{eta ? eta : ""}</span>
                    </div>
                  </PriceSec>
                  <ButtonSec>
                    <Button
                      onClick={() => ActionsHaldler(order_id, "cancelled")}
                      disabled={BtnLoading}
                    >
                      Reject
                    </Button>
                    <Button
                      className="approve"
                      onClick={() => ActionsHaldler(order_id, "approved")}
                      disabled={BtnLoading}
                    >
                      Approve
                    </Button>
                  </ButtonSec>
                </OrderQuotesMain>
              );
            })
          : !Loading && <NotFoundIcon MT="20" />}
      </CustomScrollbar>
    </ContactMain>
    // </OrdersLayout>
  );
};

export default OrderQuotes;
